<template>
    <Select2 class="select2-selection__rendered" v-model="select2Value" :options="options" @change="changeValue" v-bind="$attrs" style="width: auto;"/>
</template>
<script>
    import store from '@/store';
    import Select2 from '@/components/common/selector/select2/Select2.vue'
    export default {        
        components:{
            "Select2" : Select2
        },
        data(){
            return {
                select2Value: null,
                options: []
            }
        },
        props : {
            value : null,
            siteId : 0
            
        },
        watch: {
            value: {
                handler(newValue, oldValue){
                    this.select2Value = newValue;             
                }
            }
        },
        created(){
            this.options.push({id : "", text: "---订单渠道---"});
            this.loadOptionsFromServer();
        },
        methods:{
            loadOptionsFromServer(){
                var that = this;
                that.$http.get(store.ctx+ "/msu/common/data/orderchannel/list?siteId=" + that.siteId).then((response)=>{
                    if(response.data)
                        response.data.forEach(function(e, i){
                            that.options.push({id: e.id, text : e.platformName + "/" + e.name});
                        });
                });
            },
            changeValue () {
                this.$emit("input", this.select2Value);
                this.$emit("change", this.select2Value);
            }
        }
    }
</script>
<style>
    .select2-inline {
        float: left;
        width: 250px;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/selector/data/selectorOrderChannel.vue